import { useState } from 'react'
import { migrateVerses } from '@/api/admin'
import { useSetToast } from '@/hooks'
import { Button } from '@/components/priority'

export const TransferVersesButton = () => {
  const [loading, setLoading] = useState(false)
  const setToast = useSetToast()

  const launchThemes = async () => {
    setLoading(true)

    try {
      await migrateVerses()

      setToast({
        icon: 'check',
        text: 'Verses transfer requested successfully',
      })
    } catch (error) {
      setToast({
        text:
          error.message === 'Request timed out'
            ? 'Operation timed out. Please try again later.'
            : 'Failed to transfer verses',
      })
    } finally {
      setLoading(false)
    }
  }

  const buttonText = loading
    ? '🎨 Requesting transfer...'
    : '🎨 Request to transfer over verses from S3'

  return (
    <Button primary onClick={launchThemes} disabled={loading}>
      {buttonText}
    </Button>
  )
}

export default TransferVersesButton
